import axios from "axios";
import { Base_URL } from "../url";

export const fetchPayRolls = async () => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/PayRollGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching pay rolls!";
  }
};

export const generateSelectedPayRolls = async (payrollIds) => {
  console.log(payrollIds, 'payrollIds')
  return;
  try {
    const response = await axios.post(`${Base_URL}/SalaryProcess/DownloadCsvData`, {
      payrollIds: payrollIds
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error generating pay rolls!";
  }
};

export const generatePayRolls = async (payrollData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/PayrollHeaderItem?UserName=${userName}`,
      payrollData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error generating pay rolls!";
  }
};

export const downloadPayrollData = async (payrollIds) => {
  try {
    const formattedData = payrollIds.map(id => ({ payrollIds: id }));
    const response = await axios.post(`${Base_URL}/SalaryProcess/DownloadExcelData`, formattedData, {
      responseType: 'blob' 
    });
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading payroll data!";
  }
};